/* AVELOR: consent-aware attribution. Personal form fields never enter analytics. */
(() => {
  'use strict';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const types = ['private_home', 'interior_design', 'hospitality', 'retailer'];
  const classify = host => {
    if (/^(www\.)?(google\.[a-z.]+|bing\.com|duckduckgo\.com)$/.test(host)) return 'search';
    if (['chatgpt.com','chat.openai.com','perplexity.ai','gemini.google.com','copilot.microsoft.com','claude.ai'].some(x => host === x || host.endsWith('.'+x))) return 'ai_assistant';
    if (['instagram.com','facebook.com','pinterest.com','tiktok.com','linkedin.com'].some(x => host === x || host.endsWith('.'+x))) return 'social';
    return '';
  };
  function source() {
    if (!allowed()) return {source:'unavailable',evidence:'not_consented'};
    const saved = read('avelor:source');
    if (saved && Date.now()-saved.at < 1800000) return saved;
    let host = ''; try {host = new URL(document.referrer).hostname.toLowerCase();} catch (_) {}
    const tag = (new URLSearchParams(location.search).get('utm_source') || '').toLowerCase();
    const tagged = classify(tag) || ({google:'search',bing:'search',instagram:'social',facebook:'social',chatgpt:'ai_assistant',perplexity:'ai_assistant'})[tag];
    const external = host && host !== location.hostname;
    const s = {source:tagged || classify(host) || (external ? 'referral' : 'direct_or_unknown'), evidence:tagged ? 'tagged' : external ? 'referral' : 'unknown',at:Date.now()};
    write('avelor:source',s); return s;
  }
  function hidden(form, key, value) {
    let input = form.querySelector(`[name="contact[${key}]"]`);
    if (!input) {input = document.createElement('input'); input.type='hidden';input.name=`contact[${key}]`;form.append(input);}
    input.value = value;
  }
  function publishSuccess() {
    if (!allowed()) return;
    const form = document.getElementById('AvelorEnquiry');
    const pending = read('avelor:pending');
    if (!form?.querySelector('[data-avelor-success]') || !pending || !pending.consent || pending.path !== location.pathname || Date.now()-pending.at > 7200000 || !types.includes(pending.type) || !window.Shopify?.analytics?.publish) return;
    if (read('avelor:sent:'+pending.id)) return;
    if (window.Shopify.analytics.publish('avelor_enquiry_success', {lead_id:pending.id,form_id:'AvelorEnquiry',lead_type:pending.type,lead_source:pending.source,source_evidence:pending.evidence,reported_source:pending.reported}) !== false) {
      write('avelor:sent:'+pending.id,true);remove('avelor:pending');
    }
  }
  function init() {
    const form = document.getElementById('AvelorEnquiry');
    if (form && !form.querySelector('[data-avelor-success]')) {
      const id = 'AV-'+crypto.randomUUID().toUpperCase();
      hidden(form,'enquiry_reference',id);
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        const consent=allowed(), s=source();
        hidden(form,'observed_source',s.source);hidden(form,'source_evidence',s.evidence);
        // Store attribution only with permission; an unconsented form still submits normally.
        if (consent) write('avelor:pending',{id,path:location.pathname,at:Date.now(),consent,type:form.querySelector('#av-type')?.value || 'private_home',source:s.source,evidence:s.evidence,reported:form.querySelector('#av-discovery')?.value || 'not_provided'});
        else remove('avelor:pending');
      });
    }
    document.addEventListener('click',event => {
      const link=event.target.closest?.('a[href]');
      if (!link) return;
      if (link.matches('[data-av-cookie-preferences]') && window.privacyBanner?.showPreferences) {
        event.preventDefault(); window.privacyBanner.showPreferences(); return;
      }
      if (link.href.startsWith('https://wa.me/905057855786') && allowed()) window.Shopify?.analytics?.publish?.('avelor_whatsapp_click',{page_path:location.pathname,contact_method:'whatsapp'});
    });
    publishSuccess();
    window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.2'}],error => {if (!error && allowed()) {source();publishSuccess();}});
  }
  document.addEventListener('visitorConsentCollected',() => {
    if (allowed()) {source();publishSuccess();} else {remove('avelor:source');remove('avelor:pending');}
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
